import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface IAnnouncementsResponse {
  message: string;
  payload: IAnnouncementsPayload;
}

export interface IAnnouncementsPayload {
  content: IAnnouncementsContent[];
  page: IAnnouncementsPage;
}

export interface IAnnouncementsContent {
  id: string;
  title: string;
  status: string;
  expirationDate: string;
  organization: IOrganizationContent;
  createdAt: string;
  content: string;
}

export interface IOrganizationContent {
  organizationId: string;
  organizationName: string;
  logoUrl?: string;
}

export interface IAnnouncementsPage {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root',
})
export class AnnouncementsService {
  constructor(private api: ApiService) {}

  getAnnouncements(): Observable<IAnnouncementsContent[]> {
    const params = new HttpParams().set('size', '5');
    return this.api
      .GET<IAnnouncementsResponse>('announcements/published', { params })
      .pipe(map((response) => response.payload.content));
  }
}
